(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jord-exosomes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jord-exosomes-accordion')) {
    customElements.define('jord-exosomes-accordion', class extends HTMLElement {
      static editorSelections = new Map();
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.items = [...this.querySelectorAll('[data-topic]')];
        this.buttons = this.items.map(item => item.querySelector('button'));
        this.panels = this.items.map(item => item.querySelector('.exo-accordion__panel'));
        this.backgrounds = [...this.querySelectorAll('[data-background-for]')];
        this.card = this.querySelector('.exo-accordion__card');
        this.desktop = matchMedia('(min-width:750px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
        this.motionDuration = Math.min(2500, Math.max(500, Number(this.dataset.motionDuration) || 1400));
        this.zoomStep = Math.min(.15, Math.max(0, Number(this.dataset.zoomStep) / 100 || 0));
        this.dataset.enhanced = 'true';
        const saved = this.dataset.editor === 'true' ? this.constructor.editorSelections.get(this.dataset.sectionId) : undefined;
        const savedIndex = this.items.findIndex(item => item.dataset.blockId === saved);
        const initial = savedIndex >= 0 ? savedIndex : this.items.length && (this.desktop.matches || this.dataset.openFirst === 'true') ? 0 : null;
        this.select(initial, false);
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => {
            if (this.desktop.matches && this.active === index) return;
            this.select(this.active === index ? null : index);
          }, { signal });
          button.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowDown') target = (index + 1) % this.buttons.length;
            if (event.key === 'ArrowUp') target = (index + this.buttons.length - 1) % this.buttons.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = this.buttons.length - 1;
            if (target !== undefined) { event.preventDefault(); this.buttons[target].focus(); }
          }, { signal });
        });
        this.desktop.addEventListener('change', () => {
          this.select(this.desktop.matches && this.active === null && this.items.length ? 0 : this.active, false);
        }, { signal });
        window.addEventListener('resize', () => this.cancelHeightAnimation(), { signal });
        this.reducedMotion.addEventListener('change', () => this.cancelHeightAnimation(), { signal });
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target) && event.detail?.sectionId !== this.dataset.sectionId) return;
          const index = this.items.findIndex(item => item.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.select(index, false);
        }, { signal });
      }
      select(active, animate = true) {
        if (!Number.isInteger(active) || active < 0 || active >= this.items.length) active = null;
        const previousHeight = this.card.getBoundingClientRect().height;
        this.cancelHeightAnimation();
        this.active = active;
        this.dataset.active = active === null ? 'none' : String(active);
        const blockId = active === null ? null : this.items[active].dataset.blockId;
        if (this.dataset.editor === 'true') this.constructor.editorSelections.set(this.dataset.sectionId, blockId);
        this.style.setProperty('--exo-zoom-scale', String(this.dataset.zoom === 'true' && active !== null ? 1 + Math.min(.3, active * this.zoomStep) : 1));
        const backgroundId = this.backgrounds.some(layer => layer.dataset.backgroundFor === blockId) ? blockId : 'default';
        this.backgrounds.forEach(layer => { layer.dataset.visible = String(layer.dataset.backgroundFor === backgroundId); });
        this.items.forEach((item, index) => {
          const expanded = index === active;
          item.dataset.open = String(expanded);
          this.buttons[index].setAttribute('aria-expanded', String(expanded));
          this.buttons[index].setAttribute('aria-disabled', String(expanded && this.desktop.matches));
          this.panels[index].hidden = !expanded;
        });
        const targetHeight = this.card.getBoundingClientRect().height;
        if (animate && !this.reducedMotion.matches && Math.abs(targetHeight - previousHeight) > 1) {
          const animation = this.card.animate([{ height: previousHeight + 'px' }, { height: targetHeight + 'px' }], { duration: this.motionDuration, easing: 'cubic-bezier(.22,.61,.36,1)' });
          this.heightAnimation = animation;
          animation.onfinish = () => { if (this.heightAnimation === animation) this.heightAnimation = null; };
        }
      }
      cancelHeightAnimation() { this.heightAnimation?.cancel(); this.heightAnimation = null; }
      disconnectedCallback() { this.cancelHeightAnimation(); this.abort?.abort(); this.abort = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jord-formula-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jord-formula-stories')) {
    customElements.define('jord-formula-stories', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.imageClones = new Map();
        this.activeKey = null;
        const options = { signal: this.controller.signal };
        const anchor = this.querySelector('[data-jfs-anchor]');
        const anchorName = this.dataset.anchorName;
        if (anchor && anchorName && !document.getElementById(anchorName)) anchor.id = anchorName;
        this.refresh();
        this.addEventListener('click', event => {
          const button = event.target.closest('.jfs-trigger');
          if (button?.closest('jord-formula-stories') === this) this.select(this.activeKey === button.dataset.key ? null : button.dataset.key);
        }, options);
        this.addEventListener('keydown', event => {
          const button = event.target.closest('.jfs-trigger');
          if (!button || !this.buttons.includes(button)) return;
          const index = this.buttons.indexOf(button);
          let target;
          if (event.key === 'ArrowDown') target = this.buttons[(index + 1) % this.buttons.length];
          if (event.key === 'ArrowUp') target = this.buttons[(index - 1 + this.buttons.length) % this.buttons.length];
          if (event.key === 'Home') target = this.buttons[0];
          if (event.key === 'End') target = this.buttons[this.buttons.length - 1];
          if (target) {
            event.preventDefault();
            target.focus();
          }
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const sectionId = event.detail?.sectionId;
          if (sectionId && sectionId !== this.dataset.sectionId) return;
          if (!sectionId && !this.contains(event.target)) return;
          this.refresh();
          let tile = event.target instanceof Element ? event.target.closest('.jfs-tile') : null;
          if (tile?.closest('jord-formula-stories') !== this) {
            const selected = Array.from(this.querySelectorAll('[data-jfs-child-id]')).find(item => item.dataset.jfsChildId === event.detail?.blockId);
            tile = selected?.closest('.jfs-tile');
          }
          const button = tile?.querySelector('.jfs-trigger') || this.buttons.find(item => item.dataset.key === event.detail?.blockId);
          if (button && this.buttons.includes(button)) this.select(button.dataset.key);
        }, options);
        this.observer = new MutationObserver(records => {
          if (records.some(record => !(record.target instanceof Element) || !record.target.closest('.jfs-art'))) this.refresh();
        });
        this.observer.observe(this, { childList: true, subtree: true });
      }
      refresh() {
        this.buttons = Array.from(this.querySelectorAll('.jfs-trigger')).filter(button => button.closest('jord-formula-stories') === this);
        const art = this.querySelector('.jfs-art');
        const templates = Array.from(this.querySelectorAll('.jfs-image-template')).filter(template => template.closest('jord-formula-stories') === this);
        const activeTemplates = new Set(templates);
        this.imageClones.forEach((image, template) => {
          if (!activeTemplates.has(template)) {
            image.remove();
            this.imageClones.delete(template);
          }
        });
        if (art) templates.forEach(template => {
          if (!this.imageClones.has(template) && template.content.firstElementChild) {
            const image = template.content.firstElementChild.cloneNode(true);
            art.append(image);
            this.imageClones.set(template, image);
          }
        });
        this.layers = Array.from(art?.querySelectorAll('.jfs-image') || []);
        this.buttons.forEach(button => {
          const tile = button.closest('.jfs-tile');
          const grid = tile.querySelector('.jfs-child-grid');
          const count = grid ? Array.from(grid.children).filter(child => child.classList.contains('jfs-fact')).length : 0;
          tile.style.setProperty('--jfs-fact-columns', String(Math.min(Math.max(count, 1), Number(tile.dataset.factColumns) || 1)));
          tile.style.setProperty('--jfs-fact-mobile-columns', String(Math.min(Math.max(count, 1), Number(tile.dataset.factMobileColumns) || 1)));
        });
        this.querySelector('.jfs-grid')?.classList.toggle('jfs-grid--intro-only', this.buttons.length === 0);
        if (!this.buttons.some(button => button.dataset.key === this.activeKey)) this.activeKey = null;
        this.select(this.activeKey);
      }
      select(key) {
        this.activeKey = key;
        this.dataset.state = key || 'none';
        this.buttons.forEach(button => {
          const open = button.dataset.key === key;
          const tile = button.closest('.jfs-tile');
          const answer = tile.querySelector('.jfs-answer');
          if (!open && answer.contains(document.activeElement)) button.focus({ preventScroll: true });
          button.setAttribute('aria-expanded', String(open));
          tile.dataset.open = String(open);
          const symbol = open ? '−' : '+';
          const icon = button.querySelector('.jfs-plus');
          if (icon.textContent !== symbol) icon.textContent = symbol;
          answer.inert = !open;
          answer.setAttribute('aria-hidden', String(!open));
        });
        const layerKey = this.layers.some(layer => layer.dataset.imageFor === key) ? key : 'none';
        this.layers.forEach(layer => { layer.dataset.active = String(layer.dataset.imageFor === layerKey); });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.imageClones?.forEach(image => image.remove());
        this.controller = null;
        this.imageClones = null;
        this.buttons = [];
        this.layers = [];
        const anchor = this.querySelector('[data-jfs-anchor]');
        const anchorName = this.dataset.anchorName;
        if (anchorName && anchor?.id === anchorName) {
          anchor.id = anchorName + '-' + this.dataset.sectionId;
          const next = Array.from(document.querySelectorAll('jord-formula-stories')).find(section => section !== this && section.isConnected && section.dataset.anchorName === anchorName);
          const nextAnchor = next?.querySelector('[data-jfs-anchor]');
          if (nextAnchor && !document.getElementById(anchorName)) nextAnchor.id = anchorName;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jord-home-statement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jord-statement-video')) {
    customElements.define('jord-statement-video', class extends HTMLElement {
      connectedCallback() {
        this.onReady = () => this.initialize();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
        } else {
          this.initialize();
        }
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.initialized = true;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.updatePlayback = () => this.syncPlayback();
        this.onInteraction = event => {
          if (event.isTrusted) this.syncPlayback();
        };
        this.mobileQuery.addEventListener('change', this.updatePlayback);
        this.motionQuery.addEventListener('change', this.updatePlayback);
        document.addEventListener('visibilitychange', this.updatePlayback);
        window.addEventListener('pageshow', this.updatePlayback);
        document.addEventListener('pointerup', this.onInteraction, { passive: true });
        document.addEventListener('touchend', this.onInteraction, { passive: true });
        document.addEventListener('keydown', this.onInteraction);
        this.syncPlayback();
      }

      canPlay() {
        return this.isConnected && !this.motionQuery.matches && !document.hidden;
      }

      syncPlayback() {
        if (!this.initialized || !this.isConnected) return;
        const screen = this.mobileQuery.matches ? 'mobile' : 'desktop';
        if (screen !== this.activeScreen || this.motionQuery.matches) {
          this.removePlayer();
          this.activeScreen = screen;
        }
        if (!this.canPlay()) {
          if (this.player) {
            this.player.autoplay = false;
            this.player.pause();
          }
          return;
        }
        const template = this.querySelector(`template[data-screen="${screen}"]`);
        const video = template?.content.querySelector('video');
        if (!video) return;
        if (!this.player) {
          const player = video.cloneNode(true);
          this.player = player;
          player.autoplay = true;
          player.loop = true;
          player.muted = true;
          player.defaultMuted = true;
          player.playsInline = true;
          player.preload = 'auto';
          player.setAttribute('muted', '');
          player.setAttribute('playsinline', '');
          player.oncanplay = this.updatePlayback;
          player.onplaying = () => {
            if (this.player !== player || !this.canPlay()) {
              player.pause();
              return;
            }
            player.classList.add('is-playing');
          };
          player.onerror = () => player.classList.remove('is-playing');
          this.append(player);
        }
        const player = this.player;
        player.autoplay = true;
        if (!player.paused || this.playPending) return;
        const request = {};
        this.playPending = request;
        const finish = () => {
          if (this.playPending === request) this.playPending = null;
        };
        const failed = error => {
          if (this.player !== player || !this.canPlay() || error?.name === 'AbortError') return;
          player.classList.remove('is-playing');
        };
        try {
          Promise.resolve(player.play()).catch(failed).finally(finish);
        } catch (error) {
          failed(error);
          finish();
        }
      }

      removePlayer() {
        this.playPending = null;
        const player = this.player;
        this.player = null;
        if (!player) return;
        player.oncanplay = null;
        player.onplaying = null;
        player.onerror = null;
        player.autoplay = false;
        player.pause();
        player.removeAttribute('src');
        player.querySelectorAll('source').forEach(source => source.remove());
        player.load();
        player.remove();
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.onReady);
        this.mobileQuery?.removeEventListener('change', this.updatePlayback);
        this.motionQuery?.removeEventListener('change', this.updatePlayback);
        document.removeEventListener('visibilitychange', this.updatePlayback);
        window.removeEventListener('pageshow', this.updatePlayback);
        document.removeEventListener('pointerup', this.onInteraction);
        document.removeEventListener('touchend', this.onInteraction);
        document.removeEventListener('keydown', this.onInteraction);
        this.removePlayer();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jord-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jord-product-details')) {
    customElements.define('jord-product-details', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.jpd-item');
          if (item) item.open = true;
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jord-press-carousel')) {
    customElements.define('jord-press-carousel', class extends HTMLElement {
      connectedCallback() {
        if (!this.isConnected || (this.abort && !this.abort.signal.aborted)) return;
        this.viewport = this.querySelector('[data-press-viewport]');
        this.track = this.querySelector('[data-press-track]');
        this.original = this.querySelector('[data-press-original]');
        if (!this.viewport || !this.track || !this.original || !this.original.children.length) {
          if (!this.readyObserver) {
            this.readyObserver = new MutationObserver(() => {
              if (this.isConnected) this.connectedCallback();
            });
            this.readyObserver.observe(this, { childList: true, subtree: true });
          }
          return;
        }
        this.readyObserver?.disconnect();
        this.readyObserver = null;

        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hovered = false;
        this.focused = false;
        this.blockSelected = false;

        this.viewport.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch' || this.dataset.hoverPause !== 'true') return;
          this.hovered = true;
          this.updatePlayback();
        }, options);
        this.viewport.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.updatePlayback();
        }, options);
        this.viewport.addEventListener('focusin', (event) => {
          if (this.focused || !event.target.matches(':focus-visible')) return;
          this.focused = true;
          this.refresh();
        }, options);
        this.viewport.addEventListener('focusout', () => {
          if (!this.focused) return;
          queueMicrotask(() => {
            if (!this.isConnected || this.viewport.contains(document.activeElement)) return;
            this.focused = false;
            this.refresh();
          });
        }, options);
        this.addEventListener('shopify:block:select', () => {
          this.blockSelected = true;
          this.refresh();
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.blockSelected = false;
          this.refresh();
        }, options);
        this.motionQuery.addEventListener('change', () => this.refresh(), options);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.refresh());
        });
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.original);
        this.refresh();
      }

      disconnectedCallback() {
        this.readyObserver?.disconnect();
        this.readyObserver = null;
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.resizeFrame);
        this.animation?.cancel();
        this.querySelectorAll('[data-press-clone]').forEach((clone) => clone.remove());
      }

      refresh() {
        if (!this.isConnected) return;
        const oldDuration = this.animation?.effect.getTiming().duration;
        const progress = oldDuration ? (Number(this.animation.currentTime) % oldDuration) / oldDuration : 0;
        this.animation?.cancel();
        this.animation = null;
        this.track.querySelectorAll('[data-press-clone]').forEach((clone) => clone.remove());
        const moving = this.dataset.autoplay === 'true' && !this.motionQuery.matches && !this.focused && !this.blockSelected;
        this.dataset.moving = String(moving);
        if (!moving) return;

        const distance = this.original.getBoundingClientRect().width;
        const visibleWidth = this.viewport.getBoundingClientRect().width;
        if (!distance || !visibleWidth) return;
        const copyCount = Math.ceil(visibleWidth / distance) + 1;
        for (let index = 0; index < copyCount; index += 1) {
          const clone = this.original.cloneNode(true);
          clone.removeAttribute('data-press-original');
          clone.setAttribute('data-press-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('*').forEach((element) => {
            [...element.attributes].forEach((attribute) => {
              if (attribute.name === 'id' || attribute.name === 'data-block-id' || attribute.name.startsWith('data-shopify')) {
                element.removeAttribute(attribute.name);
              }
            });
          });
          clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          clone.addEventListener('pointerdown', (event) => {
            if (event.target.closest('a')) event.preventDefault();
          });
          clone.querySelectorAll('img').forEach((img) => { img.loading = 'eager'; });
          this.track.append(clone);
        }

        const duration = distance / Math.max(10, Number(this.dataset.speed) || 40) * 1000;
        const frames = [{ transform: 'translateX(0)' }, { transform: `translateX(-${distance}px)` }];
        if (this.dataset.direction === 'right') frames.reverse();
        this.animation = this.track.animate(frames, { duration, iterations: Infinity, easing: 'linear' });
        this.animation.currentTime = progress * duration;
        this.updatePlayback();
      }

      updatePlayback() {
        if (!this.animation) return;
        if (this.hovered || document.hidden) this.animation.pause();
        else this.animation.play();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
